var _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgArrowSquareOut(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#ArrowSquareOut_svg__clip0_18659_4099)",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M10.969 5.281v-3.25h-3.25M6.906 6.094L10.97 2.03M9.344 6.906v3.657a.406.406 0 01-.406.406h-6.5a.407.407 0 01-.407-.406v-6.5a.406.406 0 01.406-.407h3.657"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "ArrowSquareOut_svg__clip0_18659_4099"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h13v13H0z"
  })))));
}

export default SvgArrowSquareOut;